import { Component } from '@angular/core';

@Component({
  selector: 'app-payment-panel-stripe-twint',
  template: `
    <app-payment-panel-stripe-generic
      type="STRIPE_TWINT"
      [isPayButtonVisible]="true"
      payButtonText="payment.pay-with-twint"
    ></app-payment-panel-stripe-generic>
  `,
})
export class PaymentPanelStripeTwintComponent {}
